export default __webpack_public_path__ + "static/media/bracket-right.b2011e0d.svg";